import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'

import { appReducer } from 'store/appReducer'

const reduxDevtoolsCompose =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // eslint-disable-line
    actionsBlacklist: null, // ['@@redux-form']
  })

const configureStore = () => {
  const middlewares = [thunkMiddleware]
  const composeEnhancers = reduxDevtoolsCompose || compose

  const store = createStore(appReducer, /* preloadedState, */ composeEnhancers(applyMiddleware(...middlewares)))

  return store
}

export const store = configureStore()
